import { render, staticRenderFns } from "./DateTicketClosedFilter.vue?vue&type=template&id=71daad04&scoped=true&"
import script from "./DateTicketClosedFilter.vue?vue&type=script&lang=js&"
export * from "./DateTicketClosedFilter.vue?vue&type=script&lang=js&"
import style0 from "./DateTicketClosedFilter.vue?vue&type=style&index=0&id=71daad04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71daad04",
  null
  
)

export default component.exports